"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductListPageController = void 0;
var _components = require("../../components");
var _personalProductListEditContext = require("../../contexts/personalProductListEditContext");
var _PageController = require("../PageController");
var _ProductList = require("../ProductList");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file */ const ProductListPageController = (param)=>{
    let { breadcrumbs, productBoxConfiguration } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_PageController.PageController, {
        breadcrumbs: breadcrumbs,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.ScrollToTop, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_personalProductListEditContext.PersonalProductListEditProvider, {
                productBoxConfiguration: productBoxConfiguration,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ProductList.ProductList, {})
            })
        ]
    });
};
exports.ProductListPageController = ProductListPageController;
